// Auto-generated icon module
const svg = `<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
  <path d="M13.2812 12.6249C13.2812 15.7315 10.7558 18.25 7.64049 18.25C4.52519 18.25 2 15.7323 2 12.6249C2 9.51756 4.52538 7 7.64049 7C10.7556 7 13.2812 9.51832 13.2812 12.6249ZM19.4691 12.6249C19.4691 15.5494 18.2063 17.9199 16.6487 17.9199C15.0912 17.9199 13.8284 15.5486 13.8284 12.6249C13.8284 9.70119 15.0912 7.32989 16.6487 7.32989C18.2063 7.32989 19.4691 9.70119 19.4691 12.6249ZM22 12.6249C22 15.2451 21.5558 17.369 21.008 17.369C20.4603 17.369 20.0161 15.2443 20.0161 12.6249C20.0161 10.0055 20.4603 7.88079 21.0082 7.88079C21.5562 7.88079 22 10.0049 22 12.6249Z" />
</svg>
`;

export { svg as default };
//# sourceMappingURL=it-medium-CAfBjUKV.js.map
